export const BudgetRouting = [
  {
    path: "/work-manage/budget/list",
    name: "work-manage-budget-list",
    meta: { title: "施工预算" },
    notice: { type: "project_work_budget_examine", hasNotice: false },
    component: () => import("@/views/work-manage/budget/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/budget/create",
    name: "work-manage-budget-create",
    meta: { title: "新增施工预算",comName:"workManageBudgetFormCreate" },
    component: () => import("@/views/work-manage/budget/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/budget/edit/:id",
    name: "work-manage-budget-edit",
    meta: { title: "编辑施工预算",comName:"workManageBudgetFormCreate" },
    component: () => import("@/views/work-manage/budget/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/budget/detail/:id",
    name: "work-manage-budget-detail",
    meta: { title: "施工预算详情" },
    component: () => import("@/views/work-manage/budget/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/budget/flowPrint/:id",
    name: "work-manage-budget-flow-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/budget/flow-print/index.vue"),
  }
];
